import React from 'react';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import {
  Table, Drawer, DatePicker, Space, Input,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import withAuth from '@common/hocs/withAuth';
// import withPermissions from '@common/hocs/withPermissions';
import MainLayout from '@common/layouts/MainLayout';

import LogDetail from './LogDetail';
import useDispositivosLogs from './useDispositivos_Logs';
import styles from './Dispositivos_Logs.module.less';

const { RangePicker } = DatePicker;
dayjs.extend(weekday);
dayjs.extend(localeData);

function Dispositivos_Logs() {

  const { t } = useTranslation();
  const {
    loading,
    columns,
    dataSource,
    selectedItem,
    setSelectedItem,
    pagination,
    handleTableChange,
    onChangeRangeDates,
    onSearch,
  } = useDispositivosLogs();

  return (
    <MainLayout>
      <Space size="large" style={{ marginBottom: 24 }}>
        <RangePicker
          showTime
          defaultValue={[dayjs().subtract(30, 'days'), dayjs()]}
          onChange={onChangeRangeDates}
        />
        <Input.Search
          enterButton
          allowClear
          onSearch={onSearch}
          loading={loading}
          placeholder={t('common.find')}
        />
      </Space>

      <Table
        className={styles.table}
        loading={loading}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={dataSource}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey={({ date, device }) => `${date}_${device}`}
      />

      <Drawer
        visible={selectedItem !== null}
        onClose={() => setSelectedItem(null)}
        width="auto"
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
      >
        <LogDetail {...selectedItem} />
      </Drawer>
    </MainLayout>
  );

}

export default withAuth(Dispositivos_Logs);
